// @flow
import _ from 'lodash';

import type { TDraftLeaguesReducer } from '../../types';

export const getWaiversFree = (
	state: TDraftLeaguesReducer
) => _.get(state, 'leagues.waiver_free.ordered_ids', []);

export default getWaiversFree;